
export const BACKGROUNDS = [
    [
        'Pokusná myš',
        { name: 'Kouzelná střela', type: 'Kouzlo' },
        { name: 'Olověný plášť', type: 'Těžká zbroj', shape: 'tall', def: '1 def' },
    ],
    [
        'Kuchyňský slídil',
        { name: 'Štít a kabátec', type: 'Lehká zbroj', shape: 'wide', def: '1 def' },
        { name: 'Hrnce' },
    ],
    [
        'Uprchlík z klece',
        { name: 'Srozumitelnost', type: 'Kouzlo' },
        { name: 'Láhev mléka' },
    ],
    [
        'Čarodějnice',
        { name: 'Zahojení', type: 'Kouzlo' },
        { name: 'Vonná tyčka' },
    ],
    [
        'Kožešník',
        { name: 'Štít a kabátec', type: 'Lehká zbroj', shape: 'wide', def: '1 def' },
        { name: 'Silné nůžky' },
    ],
    [
        'Pouliční rváč',
        { name: 'Dýka', type: 'Lehká', attack: 'k6' },
        { name: 'Láhev kávy' },

    ],
    [
        'Žebravý kněz',
        { name: 'Zotavení', type: 'Kouzlo' },
        { name: 'Svatý symbol' },
    ],
    [
        'Honák brouků',
        { name: 'Pomocník: věrný brouk', type: 'special' },
        { name: 'Tyč, 15 cm' },
    ],
    [
        'Sládek',
        { name: 'Pomocník: opilý světlonoš', type: 'special' },
        { name: 'Soudek piva' },
    ],
    [
        'Rybář',
        { name: 'Jehla', type: 'Lehká', attack: 'k6' },
        { name: 'Síť' },
    ],
    [
        'Kovář',
        { name: 'Kladivo', type: 'Střední', attack: 'k6/k8' },
        { name: 'Pilník na železo' },
    ],
    [
        'Dráteník',
        { name: 'Drát, klubko' },
        { name: 'Elektrická lampa', usage: 6 },
    ],
    [
        'Dřevorubec',
        { name: 'Sekera', type: 'Střední', attack: 'k6/k8' },
        { name: 'Motouz, klubko' },
    ],
    [
        'Člen netopýřího kultu',
        { name: 'Tma', type: 'Kouzlo' },
        { name: 'Pytlík netopýřích zubů' },
    ],
    [
        'Horník v cínovém dole',
        { name: 'Krumpáč', type: 'Střední', attack: 'k6/k8' },
        { name: 'Lucerna' },
    ],
    [
        'Sběrač odpadků',
        { name: 'Hák na odpadky', type: 'Těžká', attack: 'k10', shape: 'tall' },
        { name: 'Zrcátko' },
    ],
    [
        'Stěnolezec',
        { name: 'Rybářský háček' },
        { name: 'Nit, cívka' },
    ],
    [
        'Kupec',
        { name: 'Pomocník: tažná krysa', type: 'special' },
        { name: 'Směnka od šlechtice na 20 ď' },
    ],
    [
        'Vorař',
        { name: 'Kladivo', type: 'Střední', attack: 'k6/k8' },
        { name: 'Dřevěné klíny' },
    ],
    [
        'Honák žížal',
        { name: 'Tyč, 15 cm' },
        { name: 'Mýdlo' },
    ],
    [
        'Vlaštovkář',
        { name: 'Rybářský háček' },
        { name: 'Ochranné brýle' },
    ],
    [
        'Kanálník',
        { name: 'Pilník na železo' },
        { name: 'Nit, cívka' },
    ],
    [
        'Žalářník',
        { name: 'Kopí', type: 'Těžká', attack: 'k10', shape: 'tall' },
        { name: 'Řetěz, 15 cm' },
    ],
    [
        'Pěstitel hub',
        { name: 'Sušené houby' },
        { name: 'Maska proti spórám' },
    ],
    [
        'Stavitel hrází',
        { name: 'Lopata' },
        { name: 'Dřevěné klíny' },
    ],
    [
        'Kartograf',
        { name: 'Brk a inkoust' },
        { name: 'Kompas' },
    ],
    [
        'Vykradač pastiček',
        { name: 'Kus sýra' },
        { name: 'Lepidlo' },
    ],
    [
        'Tulák',
        { name: 'Stan', shape: 'tall' },
        { name: 'Mapa k pokladu, pochybná' },
    ],
    [
        'Pěstitel obilí',
        { name: 'Kopí', type: 'Těžká', attack: 'k10', shape: 'tall' },
        { name: 'Píšťalka' },
    ],
    [
        'Poslíček',
        { name: 'Deka' },
        { name: 'Dokumenty, zapečetěné' },
    ],
    [
        'Trubadúr',
        { name: 'Hudební nástroj' },
        { name: 'Maskovací sada' },
    ],
    [
        'Hazardní hráč',
        { name: 'Zatížené kostky' },
        { name: 'Zrcátko' },
    ],
    [
        'Sběrač mízy',
        { name: 'Vědro' },
        { name: 'Dřevěné klíny' },
    ],
    [
        'Včelař',
        { name: 'Sklenice medu' },
        { name: 'Síť' },
    ],
    [
        'Knihovník',
        { name: 'Útržek ze starodávné knihy' },
        { name: 'Brk a inkoust' },
    ],
    [
        'Zchudlý šlechtic',
        { name: 'Plstěný klobouk' },
        { name: 'Parfém' },
    ],
];

export const FIRST_NAMES = [
    'Ada',
    'Agáta',
    'Akácie',
    'Aloe',
    'Ambrož',
    'Anežka',
    'Anýz',
    'Apríl',
    'Astra',
    'Augustín',
    'Azalka',
    'Bazalka',
    'Berylie',
    'Bobek',
    'Bodlák',
    'Bříz',
    'Čedar',
    'Čekanka',
    'Devětsil',
    'Edmund',
    'Eidam',
    'Elza',
    'Emil',
    'Erina',
    'Estragon',
    'Fenykl',
    'Fialka',
    'Filip',
    'Františka',
    'Gouda',
    'Grácie',
    'Gvendolína',
    'Habrovec',
    'Háta',
    'Hložek',
    'Horácio',
    'Hyacint',
    'Iris',
    'Jalovec',
    'Janek',
    'Jasan',
    'Jaspis',
    'Jeřabinka',
    'Jílovec',
    'Jiřička',
    'Karmína',
    'Klára',
    'Kmínek',
    'Konrád',
    'Kostřava',
    'Krokus',
    'Kuklík',
    'Květa',
    'Levandule',
    'Lilie',
    'Líska',
    'Lorenz',
    'Magnolie',
    'Majoránka',
    'Makovec',
    'Máslena',
    'Meduňka',
    'Měsíček',
    'Muškát',
    'Myrta',
    'Niva',
    'Nora',
    'Okřál',
    'Oliver',
    'Olivie',
    'Olša',
    'Opál',
    'Otýlie',
    'Pelyňka',
    'Pepřík',
    'Perla',
    'Rípčíp',
    'Rokfór',
    'Routa',
    'Rozmarín',
    'Rulík',
    'Řebřík',
    'Sedmikráska',
    'Slídie',
    'Smaragd',
    'Svízel',
    'Šafrán',
    'Šimon',
    'Šípek',
    'Šťavel',
    'Tis',
    'Vavřinec',
    'Vilík',
    'Višňa',
    'Vlnka',
    'Vrbena',
    'Vřesena',
    'Vřesík',
    'Zuzanka',
    'Žitmil',
];

export const LAST_NAMES = [
    'Bílý/Bílá',
    'Černý/Černá',
    'Čihař/Čihařová',
    'Darček/Darčeková',
    'Durman/Durmanová',
    'Hrabal/Hrabalová',
    'Chalva/Chalvová',
    'Jařinka/Jařinková',
    'Jeleňák/Jeleňáková',
    'Jeseň/Jeseňová',
    'Katzenreiser/Katzenreiserová',
    'Máselník/Máselníková',
    'Píp/Pípová',
    'Řešetlák/Řešetláková',
    'Semínko/Semínková',
    'Sníh/Sněhová',
    'Strážný/Strážná',
    'Trnka/Trnková',
    'Urobil/Urobilová',
    ' Žvanil/Žvanilová',
];

export const BIRTH_SIGNS = [
    ['Hvězda', 'Statečná/zbrklá'],
    ['Kolo', 'Pracovitá/nenápaditá'],
    ['Žalud', 'Zvědavá/paličatá'],
    ['Bouřka', 'Štědrá/popudlivá'],
    ['Měsíc', 'Moudrá/záhadná'],
    ['Matka', 'Pečující/ustaraná'],
];

export const COAT_COLORS = [
    'Čokoládová',
    'Černá',
    'Bílá',
    'Světle hnědá',
    'Šedá',
    'Namodralá',
];

export const COAT_PATTERNS = [
    'jednolitá',
    'mourovatá',
    'strakatá',
    'pruhovaná',
    'tečkovaná',
    'skvrnitá',
];

export const PHYSICAL_DETAIL = [
    'Tělo plné jizev',
    'Korpulentní tělo',
    'Vychrtlé tělo',
    'Klackovité tělo',
    'Drobné tělíčko',
    'Rozložité tělo',
    'Válečné malování',
    'Cizokrajné oblečení',
    'Elegantní oblečení',
    'Záplatované oblečení',
    'Módní oblečení',
    'Neprané oblečení',
    'Useknuté ucho',
    'Neforemný obličej',
    'Krásný obličej',
    'Baculatý obličej',
    'Jemné rysy v obličeji',
    'Protáhlý obličej',
    'Načesaná srst',
    'Dredy',
    'Nabarvená srst',
    'Oholená srst',
    'Kudrnatá srst',
    'Sametová srst',
    'Oči temné jako noc',
    'Páska přes oko',
    'Krvavě rudé oči',
    'Moudrý pohled',
    'Pronikavý pohled',
    'Blyštivé oči',
    'Zastřižený ocásek',
    'Ocásek jako bič',
    'Chocholatý ocásek',
    'Pahýl ocásku',
    'Chápavý ocásek',
    'Zakroucený ocásek',
];
